import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { catchError, finalize, map, Observable, throwError } from "rxjs";

@Injectable()
export class HttpRequestInterceptor implements HttpRequestInterceptor{
  constructor(private toastrService: ToastrService, private spinner: NgxSpinnerService){ }

  intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>>{
    this.spinner.show()

    return next.handle(req).pipe(
      map((event:HttpEvent<any>)=>{
        if(event instanceof HttpResponse){
          this.spinner.hide()
        }
        return event
      }),
      catchError( error =>{
        return throwError(() => error)
      }),
      finalize( () => {
        setTimeout( () =>{
          this.spinner.hide()
        }, 1000)
      })
    )
  }
}
